export default __webpack_public_path__ + "static/media/Avenir Next.5db0f661.ttc";